<script setup lang="ts">
import { MODAL_CLOSE, useModalStore } from '~/store/modalStore';

const props = defineProps<{
  isVisible: boolean
  title?: string
  classes?: string
  id: string
}>()

const {
  isVisible,
  title,
  id,
} = toRefs(props)

const modalStore = useModalStore();

const emit = defineEmits<{
  (event: 'close'): void;
}>();

const close = () => {
  emit('close');
};

const modal = ref(null);

const onClickOutside = (event: Event) => {
  if (!modal.value ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      (modal?.value?.contains(event.target))) return;

  modalStore.displayModal(id.value, MODAL_CLOSE);
}

onMounted(() => {
  document.addEventListener("click", onClickOutside, true);
})
</script>

<template>
  <div v-if="isVisible">
    <div class="coverlay" style="opacity: 1"/>
    <div class="modal__container modal__container--active">
      <div ref="modal" :class="`modal modal__inner  modal__inner--full-mobile ${classes ?? ''}`">
        <div class="modal__header">
          <div v-if="title" class="modal__title">
            {{title}}
          </div>
          <button class="modal__close" @click="close">
            <svg class="cicon cicon--24 cicon--s-dark"><use xlink:href="#close-v2"/></svg>
          </button>
        </div>
        <div class="modal__body modal-body" style="overflow: visible">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>
